import React from 'react'
import { Link } from 'gatsby'
import CookieConsent from 'react-cookie-consent'
import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies'

// Components
import Header from './header'
import Footer from './footer'

const Layout = ({ children, location }) => {
  return (
    <div className='flex min-h-screen flex-col bg-stone-50 text-stone-900 antialiased'>
      <a href='#main' className='sr-only focus:not-sr-only'>
        Skip to main content
      </a>
      <Header />
      <main role='main' id='main'>
        {children}
      </main>
      <Footer />
      <CookieConsent
        location='bottom'
        buttonText='Accept'
        declineButtonText='Decline'
        disableStyles
        overlay='true'
        overlayClasses='fixed inset-0 bg-black bg-opacity-60 z-40'
        buttonClasses='mx-1 px-4 py-2 inline-block rounded-lg border transform transition duration-150 ease-in-out border-white text-white hover:shadow-sm hover:-translate-y-1 hover:shadow-md'
        declineButtonClasses='mx-1 px-4 py-2 inline-block'
        containerClasses='absolute max-w-lg right-0 bottom-0 bg-cyan-800 text-white flex flex-col gap-4 text-base lg:text-lg p-3 p-8 m-4 md:m-8 text-center rounded z-50'
        contentClasses='inline-block mb-2'
        enableDeclineButton
        cookieName='gatsby-gdpr-google-tagmanager'
        onAccept={() => {
          initializeAndTrack(location)
        }}>
        <p className='pb-2'>
          {process.env.GATSBY_COMPANY_NAME} uses cookies. To see what we use cookies for, have a look at our{' '}
          <Link to='/privacy/' className='underline'>
            Privacy Policy
          </Link>
        </p>
      </CookieConsent>
    </div>
  )
}

export default Layout
